<template>
  <Transition name="down">
    <div :class="type === 'loading' ? 'xy-toast_loading' : 'xy-toast'" v-show="visible">
      <div class="xy-toast-content">
        <i class="loading rotate-element" v-if="type === 'loading'"><svg-icon name="loading" /></i>
        <i class="icon" v-else-if="type !== 'text'"><svg-icon :name="type" /></i>
        <span class="text">{{ props.message }}</span>
      </div>
    </div>
  </Transition>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import SvgIcon from '@/h5/components/SvgIcon/index.vue'
const props = defineProps({
  message: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'text'
  }
})

const visible = ref(false)

onMounted(() => {
  visible.value = true
})
</script>
<style lang="scss">
.xy-toast-container {
  position: relative;
  width: 100%;
}
</style>
<style scoped lang="scss">
.xy-toast_loading {
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  .xy-toast-content {
    width: auto;
    max-width: calc(100% - 2.5rem);
    min-height: 2.125rem;
    line-height: 2.125rem;
    padding: 0 0.75rem;
    border: 0.0625rem solid rgba(0, 0, 0, 0.75);
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    .loading {
      margin: 0.5rem 0 0.375rem 0;
      font-size: 2.125rem;
    }

    .text {
      vertical-align: middle;
    }
  }
}

.xy-toast {
  z-index: 9999;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 2.5rem);
  min-height: 2.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  .xy-toast-content {
    width: auto;
    color: #fff;
    font-size: 0.875rem;
    line-height: 1.375rem;
    padding: 0.375rem 0.75rem;
    border: 0.0625rem solid rgba(0, 0, 0, 0.75);
    background: rgba(0, 0, 0, 0.75);
    border-radius: 0.25rem;
    .icon {
      margin: 0.5rem 0 0.375rem 0;
      font-size: 2.125rem;
    }

    .text {
      vertical-align: middle;
    }
  }
}

.down-enter-from {
  opacity: 0;
}

.down-enter-active {
  transition: all 0.5s;
}

.down-enter-to {
  opacity: 1;
}

@keyframes rotateAnimation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.rotate-element {
  animation: rotateAnimation 2s linear infinite;
}
</style>
